/**
 * Exact-match detector for the ivori.ai apex landing page.
 * Deliberately strict (no substring/startsWith matching) so a routing
 * decision can never accidentally swallow an unrelated host — see
 * eduHost.js, which this mirrors.
 * ivori.localhost is included for local development: *.localhost resolves
 * to loopback automatically (no /etc/hosts entry needed) and is already
 * covered by run.py's CORS wildcard for *.localhost origins.
 */
export function isCSuiteHost(hostname) {
  const h = (hostname || '').toLowerCase();
  return (
    h === 'csuite.ivoriai.com' ||
    h === 'www.csuite.ivoriai.com' ||
    h === 'csuite.ivori.ai' ||
    h === 'www.csuite.ivori.ai' ||
    h === 'csuite.localhost'
  );
}

export function isIvoriApexHost(hostname) {
  const h = (hostname || '').toLowerCase();
  return (
    h === 'ivori.ai' ||
    h === 'www.ivori.ai' ||
    h === 'ivoriai.com' ||
    h === 'www.ivoriai.com' ||
    h === 'ivori.localhost'
  );
}

